import { render, staticRenderFns } from "./GroupItemColumn.vue?vue&type=template&id=aa199512&scoped=true&"
import script from "./GroupItemColumn.vue?vue&type=script&lang=js&"
export * from "./GroupItemColumn.vue?vue&type=script&lang=js&"
import style0 from "./GroupItemColumn.vue?vue&type=style&index=0&id=aa199512&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa199512",
  null
  
)

export default component.exports